import { useEffect } from 'react';

import { useAppDispatch } from 'app/hooks';
import { fetchAclResources } from 'common/services/api/Acls/AclResources.thunk';
import { extractStatusCode } from 'common/services/api/apiHelpers';
import { AclResource } from 'common/types/Entities';
import { handleListFetchError } from 'common/utils/errorHandlers';
import { clearEntities } from 'features/aclResources/aclResourcesSlice';
import { useSnackbar } from 'notistack';

type onChangeHandler = (aclResources: AclResource[]) => void;

export const useFetchAclsByTenantId = (onChange: onChangeHandler, tenantId: string) => {
    const dispatch = useAppDispatch();

    const { enqueueSnackbar } = useSnackbar();
    useEffect(() => {
        if(tenantId) {
            dispatch(fetchAclResources({ tenantId }))
                .unwrap()
                .catch(error => {
                    dispatch(clearEntities());
                    onChange([]);
                    handleListFetchError(extractStatusCode(error.message), 'ACL Resource', enqueueSnackbar);
                });

        } else {
            dispatch(clearEntities());
            onChange([]);
        }
    }, [tenantId]);
};
